import { Injectable } from '@angular/core'
import { GbApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-api.service'
import { CustomerPaymentMethodsResponse } from './customer-payment-methods.models'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class CustomerPaymentMethodsApiService extends GbApiService {
  getPaymentMethods(urlName: string = '', stripeCustomerUuid: string): Observable<CustomerPaymentMethodsResponse> {
    const url = `auctions/${urlName}/customers/${stripeCustomerUuid}/`
    return this.get<CustomerPaymentMethodsResponse>(url)
  }
}
